export const SUGGESTED_USERS_QUERY_KEY = 'suggestedUsers';
